import React, { Component } from "react";

class TableHeaderCell extends Component {
  render() {
    const {
      title,
      dataAlign: textAlign,
      dataSort,
      dataField,
      onChangeSort,
      sortedField,
      orderBy = "desc",
      style = {},
    } = this.props;

    let sortStyle = "fa-sort";
    if (dataField === sortedField) {
      sortStyle = `fa-sort-${orderBy}`;
    }

    let changedOrderBy = "desc";
    if (sortedField === dataField && orderBy === "desc") {
      changedOrderBy = "asc";
    }

    return (
      <th
        className="dnd-table-header-cell"
        style={{
          textAlign,
          cursor: dataSort ? "pointer" : "default",
          ...style,
        }}
        onClick={() =>
          dataSort &&
          onChangeSort({
            dataField,
            orderBy: changedOrderBy,
          })
        }>
        {title}
        {dataSort && <span className={`fa ${sortStyle} sort`} />}
      </th>
    );
  }
}

export default TableHeaderCell;
